import { ToastList, useVisibleToasts } from './ToastList'
import { useRegionMounted } from './notificationStore'

/**
 * LE REPLI DES ÉCRANS SANS CHÂSSIS (LOT-H9).
 *
 * ══════════════════════════════════════════════════════════════════════════
 * POURQUOI IL RESTE UNE PILE FLOTTANTE
 * ══════════════════════════════════════════════════════════════════════════
 *
 * `/login` et `/register` n'ont pas d'`AppShell`, donc pas de zone de
 * notification dans le flux. Il leur faut bien un endroit où atterrir. Là, la
 * contrainte de DA-002 ne s'applique pas de la même façon : il n'y a ni en-tête
 * ni cluster d'actions à recouvrir, seulement un formulaire centré.
 *
 * Deux garanties tout de même :
 *   · `pointer-events: none` sur le conteneur — un message ne peut JAMAIS
 *     intercepter un geste, même s'il passe visuellement sur un champ ;
 *   · le haut de la pile reste `--toast-stack-top`, la variable publiée par
 *     l'`AppShell` depuis H0. Elle garde exactement son rôle : hors châssis,
 *     elle n'est pas définie et le repli `1rem` s'applique — c'est déjà ce que
 *     documentait H0.
 *
 * ══════════════════════════════════════════════════════════════════════════
 * UN SEUL RENDU À LA FOIS
 * ══════════════════════════════════════════════════════════════════════════
 *
 * `useToaster` lit un registre GLOBAL : deux composants qui l'appellent rendent
 * les deux fois le même toast. Ce composant s'efface donc dès qu'une
 * `NotificationRegion` est montée — et il ne monte pas non plus le hook dans ce
 * cas, d'où la coupure en deux composants (les règles des hooks interdisent un
 * appel conditionnel dans un seul).
 */

function FloatingToasts() {
  const toasts = useVisibleToasts()

  if (toasts.length === 0) return null

  return (
    <div
      data-testid="floating-toast-stack"
      className="pointer-events-none fixed inset-x-0 z-[99999] flex flex-col items-end gap-2 px-4"
      style={{ top: 'var(--toast-stack-top, 1rem)' }}
    >
      <div className="flex w-full max-w-sm flex-col gap-2">
        <ToastList toasts={toasts} surface="floating" />
      </div>
    </div>
  )
}

export function FloatingToastStack() {
  const regionMounted = useRegionMounted()

  return regionMounted ? null : <FloatingToasts />
}

export default FloatingToastStack
